import script from "./AnnouncementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnouncementModal.vue?vue&type=script&setup=true&lang=ts"

import "./AnnouncementModal.vue?vue&type=style&index=0&id=1b05bd4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b05bd4c"]])

export default __exports__